import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, SparklesIcon, BuildingIcon, CheckCircle2Icon } from 'lucide-react';
import { SectionReveal } from '../components/SectionReveal';
import { HeroSection } from '../components/HeroSection';
import { TestimonialCard } from '../components/TestimonialCard';
export function Home() {
  return <div className="min-h-screen bg-cream" data-id="element-222">
      {/* Hero Section */}
      <HeroSection title="Devenez la bâtisseuse de votre propre liberté." subtitle="Que ce soit par la création de votre empire cosmétique ou par l'investissement stratégique, nous vous donnons les clés de votre indépendance." ctaText="Réserver un Appel de Coaching" ctaLink="https://calendly.com/sarahmarte/coaching-1-1" backgroundImage="https://cdn.magicpatterns.com/uploads/xz4VLaf3unoVk2zKV9128Q/6..png" height="full" theme="blush" data-id="element-223" />

      {/* Reassurance Bar */}
      <div className="bg-blush py-6 border-y border-white" data-id="element-224">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 text-sm font-medium text-navy/80" data-id="element-226">
            <span className="flex items-center gap-2 bg-white/50 px-4 py-2 rounded-full" data-id="element-227">
              <CheckCircle2Icon className="w-4 h-4 text-rosegold" data-id="element-228" />{' '}
              Accompagnement Premium
            </span>
            <span className="flex items-center gap-2 bg-white/50 px-4 py-2 rounded-full" data-id="element-229">
              <CheckCircle2Icon className="w-4 h-4 text-rosegold" data-id="element-230" /> Expertise
              Internationale
            </span>
            <span className="flex items-center gap-2 bg-white/50 px-4 py-2 rounded-full" data-id="element-231">
              <CheckCircle2Icon className="w-4 h-4 text-rosegold" data-id="element-232" /> Résultats
              Concrets
            </span>
          </div>
        </div>
      </div>

      {/* Double Entry Section */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-233">
        <SectionReveal data-id="element-234">
          <div className="text-center mb-16" data-id="element-235">
            <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-236">
              Choisissez votre voie vers la liberté
            </h2>
            <p className="text-navy/70 max-w-2xl mx-auto" data-id="element-237">
              Deux programmes d'excellence conçus pour les femmes ambitieuses
              prêtes à transformer leur vision en réalité.
            </p>
          </div>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-238">
          {/* Card 1: Cosmetic Empire */}
          <SectionReveal delay={0.1} data-id="element-239">
            <div className="group relative bg-white rounded-3xl h-full flex flex-col overflow-hidden shadow-xl shadow-pink-100/50 border border-blush hover:-translate-y-1 transition-transform duration-500" data-id="element-240">
              <div className="h-64 overflow-hidden relative" data-id="element-241">
                <div className="absolute inset-0 bg-rosegold/10 group-hover:bg-rosegold/0 transition-colors z-10" data-id="element-242" />
                <img src="https://cdn.magicpatterns.com/uploads/jXR8kFcsGYkhK1TGRp3Yje/543aa613-79d1-4622-9843-3adcb1cb4fa4.jpg" alt="Cosmetic Empire" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-243" />
                <div className="absolute top-6 left-6 z-20 bg-white/90 backdrop-blur-sm p-3 rounded-full shadow-sm" data-id="element-244">
                  <SparklesIcon className="w-6 h-6 text-rosegold" data-id="element-245" />
                </div>
              </div>
              <div className="p-8 md:p-10 flex flex-col flex-grow" data-id="element-246">
                <span className="text-xs font-bold tracking-widest text-rosegold uppercase mb-2" data-id="element-247">
                  Programme 10 mois
                </span>
                <h3 className="text-2xl font-serif text-navy mb-3" data-id="element-248">
                  LIBERTY — Cosmetic Brand Creation
                </h3>
                <p className="text-navy/70 mb-8 flex-grow leading-relaxed" data-id="element-249">
                  Un accompagnement One-to-One exclusif pour lancer votre marque
                  de cosmétiques de A à Z. Ne vendez pas juste des produits,
                  bâtissez un empire. Site e-commerce inclus.
                </p>
                <Link to="/cosmetic-empire" className="inline-flex items-center justify-center gap-2 bg-blush-light text-rosegold font-medium px-6 py-3 rounded-full group-hover:bg-rosegold group-hover:text-white transition-colors" data-id="element-250">
                  Découvrir le programme <ArrowRightIcon className="w-4 h-4" data-id="element-251" />
                </Link>
              </div>
            </div>
          </SectionReveal>

          {/* Card 2: Real Estate & Mindset */}
          <SectionReveal delay={0.2} data-id="element-252">
            <div className="group relative bg-white rounded-3xl h-full flex flex-col overflow-hidden shadow-xl shadow-pink-100/50 border border-blush hover:-translate-y-1 transition-transform duration-500" data-id="element-253">
              <div className="h-64 overflow-hidden relative" data-id="element-254">
                <div className="absolute inset-0 bg-blush/20 group-hover:bg-blush/0 transition-colors z-10" data-id="element-255" />
                <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2075&auto=format&fit=crop" alt="Real Estate" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-256" />
                <div className="absolute top-6 left-6 z-20 bg-white/90 backdrop-blur-sm p-3 rounded-full shadow-sm" data-id="element-257">
                  <BuildingIcon className="w-6 h-6 text-rosegold" data-id="element-258" />
                </div>
              </div>
              <div className="p-8 md:p-10 flex flex-col flex-grow" data-id="element-259">
                <span className="text-xs font-bold tracking-widest text-rosegold uppercase mb-2" data-id="element-260">
                  Coaching & Stratégie
                </span>
                <h3 className="text-2xl font-serif text-navy mb-3" data-id="element-261">
                  Programme Liberty — Real Estate
                </h3>
                <p className="text-navy/70 mb-8 flex-grow leading-relaxed" data-id="element-262">
                  Libérez-vous du salariat par l'investissement intelligent.
                  Stratégies immobilières (Dubaï, Europe, Maroc) et coaching
                  mindset de haut niveau.
                </p>
                <Link to="/programme-liberty" className="inline-flex items-center justify-center gap-2 bg-blush-light text-rosegold font-medium px-6 py-3 rounded-full group-hover:bg-rosegold group-hover:text-white transition-colors" data-id="element-263">
                  Découvrir le programme <ArrowRightIcon className="w-4 h-4" data-id="element-264" />
                </Link>
              </div>
            </div>
          </SectionReveal>
        </div>
      </section>

      {/* Testimonials Preview */}
      <section className="py-24 bg-blush-light relative overflow-hidden" data-id="element-265">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-266">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-60" data-id="element-267"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-268">
          <SectionReveal data-id="element-269">
            <div className="text-center mb-16" data-id="element-270">
              <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-271">
                Elles ont osé. Elles ont réussi.
              </h2>
              <p className="text-navy/70 max-w-2xl mx-auto" data-id="element-272">
                Des femmes qui ont choisi de bâtir leur liberté avec Sarah.
              </p>
            </div>
          </SectionReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-273">
            <TestimonialCard name="Camille Lefèvre" location="Paris, France" photo="https://cdn.magicpatterns.com/uploads/31Rcc42iUEN5M5TPqembfc/Gemini_Generated_Image_avp9ijavp9ijavp9.png" quote="Avant LIBERTY, j'avais une idée. Aujourd'hui, j'ai une vraie marque que je suis fière de porter. Sarah a transformé mon projet flou en un business solide." result="12K€ de CA premier mois" delay={0.1} data-id="element-274" />
            <TestimonialCard name="Sofia Rossi" location="Genève, Suisse" photo="https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=400&auto=format&fit=crop&crop=faces" quote="Le coaching mindset avec Sarah a été un déclic. J'ai investi dans mon premier appartement à Dubaï 4 mois après notre première session." result="Premier investissement immo" delay={0.2} data-id="element-275" />
            <TestimonialCard name="Léa Marchand" location="Lyon, France" photo="https://cdn.magicpatterns.com/uploads/3wqWBJDULBEEKkdHwbrBuD/Gemini_Generated_Image_tliphntliphntlip.png" quote="J'étais salariée, démotivée, avec une idée de marque dans la tête depuis 3 ans. Sarah m'a fait passer à l'action avec une méthode claire." result="Quittée son CDI · 6K€/mois" delay={0.3} data-id="element-276" />
          </div>
        </div>
      </section>

      {/* About Sarah Section */}
      <section className="py-24 bg-white" data-id="element-277">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-279">
            <SectionReveal className="w-full lg:w-1/2" data-id="element-280">
              <div className="relative" data-id="element-281">
                <div className="absolute -inset-4 bg-blush rounded-3xl transform -rotate-3 z-0" data-id="element-282"></div>
                <img src="https://cdn.magicpatterns.com/uploads/sqV44yVnBk4E6wwuH5XG79/ChatGPT_Image_19_mai_2026,_15_10_10.png" alt="Sarah - Fondatrice" className="relative z-10 w-full h-[600px] object-cover object-top rounded-3xl shadow-xl shadow-pink-100/50" data-id="element-283" />
                <div className="absolute -bottom-6 -right-6 z-20 bg-white p-4 rounded-full shadow-xl" data-id="element-284">
                  <SparklesIcon className="w-8 h-8 text-rosegold" data-id="element-285" />
                </div>
              </div>
            </SectionReveal>

            <SectionReveal className="w-full lg:w-1/2" delay={0.2} data-id="element-286">
              <h2 className="text-sm font-bold tracking-widest text-rosegold uppercase mb-3" data-id="element-287">
                À propos de Sarah
              </h2>
              <h3 className="text-3xl md:text-4xl font-serif text-navy mb-6" data-id="element-288">
                L'experte qui délègue pour réussir.
              </h3>
              <div className="space-y-4 text-navy/70 leading-relaxed" data-id="element-289">
                <p data-id="element-290">
                  Basée entre l'effervescence de Dubaï et l'authenticité du
                  Maroc, Sarah a bâti son succès sur une philosophie simple :
                  travailler intelligemment, pas durement.
                </p>
                <p data-id="element-291">
                  Entrepreneuse aguerrie dans l'industrie cosmétique et
                  investisseuse immobilière stratégique, elle a créé le
                  Programme Liberty pour partager les systèmes exacts qui lui
                  ont permis de s'affranchir du salariat.
                </p>
                <p data-id="element-292">
                  Son approche est directe, inspirante et sans fausses
                  promesses. Elle vous enseigne comment créer des actifs
                  rentables tout en déléguant la technique, pour que vous
                  puissiez vous concentrer sur ce qui compte vraiment : votre
                  vision.
                </p>
              </div>
              <div className="mt-10" data-id="element-293">
                <p className="font-script text-4xl text-rosegold leading-none" data-id="element-294">
                  Sarah
                </p>
                <p className="text-xs tracking-widest text-navy/50 uppercase mt-1" data-id="element-295">
                  Fondatrice · Programme Liberty
                </p>
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>
    </div>;
}